<template>
    <div id="app" style="height: 100%">
        <el-container v-if="isLogin">
            <el-header height="40px">
                <el-row style="height: 100%;width:100% ;color: #ffffff;line-height: 40px;font-size: 14px">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                            style="height:40px;text-align:right;background: url(images/header_bg.jpg) left #3459e9;">
                        <el-dropdown trigger="click" @command="handleCommand">
                              <span class="el-dropdown-link" style="color: #ffffff;">
                                [{{this.$store.state.info.username}}]已登录<i
                                      class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-refresh" command="handleUpdateData">清理缓存
                                </el-dropdown-item>
                                <el-dropdown-item icon="el-icon-edit" command="handleEditPassword">修改密码
                                </el-dropdown-item>
                                <el-dropdown-item icon="el-icon-switch-button" command="handleLogout">退出登录
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </el-header>
            <el-container style="height: calc(100% - 60px);background-color: #eaeaea">
                <el-aside width="200px" style="background-color: #FFFFFF;border-right: solid #DDDDDD 1px;">
                    <Sidebar :menuList="menuList"/>
                </el-aside>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
        <router-view v-else></router-view>
    </div>
</template>

<script>
  import Sidebar from "./pages/Sidebar/Sidebar";
  import storage from "@/utils/storage";

  export default {
    name: 'App',
    components: {
      Sidebar
    },
    data() {
      return {
        isLogin: false, // 是否登录
        menuList: storage.getParse('menus'),
      }
    },
    methods: {
      handleCommand(command) {
        if (command === 'handleLogout') this.handleLogout()
        if (command === 'handleUpdateData') this.handleUpdateData()
        if (command === 'handleEditPassword') this.handleEditPassword()
      },
      handleLogout() {
        // 退出登录
        localStorage.clear();
        this.$router.replace('/login')
      },
      handleUpdateData() {
        this.api.get('update/data').then((re) => {
          if (re && re.code === 0) {
            storage.set('menus', re.data.menus) // 存侧边栏菜单
            storage.set('router', re.data.router) // 路由信息
            this.$message({
              message: '清理成功!',
              type: 'success',
              onClose: function () {
                location.reload();
              }
            });

          } else {
            this.$message.error(re.msg)
          }
        })
      },
      handleEditPassword() {

        this.$prompt('请输入新密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^(\w){6,20}$/,
          inputErrorMessage: '密码格式不正确'
        }).then(({value}) => {

          this.api.post('edit/password', {'password': value}).then((re) => {
            if (re && re.code === 0) {
              this.$message({
                message: '修改成功!',
                type: 'success',
                onClose: function () {
                  // 退出登录
                  localStorage.clear();
                  this.$router.replace('/login')
                }
              });
            } else re && this.$message.error(re.msg || '网络错误');
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消修改'
          });
        });


      }
    },

    created() {
      // 判断是否登录
      let token = storage.get('token');
      if (token) this.isLogin = true;
    },
    watch: {
      '$route'(to) {
        // 当访问login时 清空所有缓存
        if (to.path === '/login' || to.path === 'login') {
          this.isLogin = false;
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    body {
        background-color: #666666
    }

    /*顶部导航*/
    .el-header {
        background-color: #365CED;
        text-align: center;
        line-height: 60px;
        padding: 0 20px 0 0 !important;
    }

    /*左侧菜单栏*/
    .el-aside {
        height: 100%;
        line-height: 200px;
        /*overflow-x: hidden;*/
    }

    /*主体部分*/
    .el-main {
        height: 100%;
        background-color: #ffffff;
        margin: 0 0 0 10px;
        padding: 25px;
        border-top: 10px solid #eaeaea;
        /*border-left: 10px solid #f0f0f0;*/
    }

    .el-container {
        height: 100%;
        background-color: #FFFFFF;
    }


    /* 滚动槽 */
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    ::-webkit-scrollbar-track {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.12);
        -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }


    /*Avue的搜索部分*/
    .avue-crud {
        width: 100%;
    }

    .avue-crud__search .avue-form__group {
        padding: 15px 0 5px 0;
        /*background-color: #FAFAFA;*/
        background-color: #FAFAFA !important;
        border-bottom: solid 1px #EBEEF5;
    }

    /*选中左侧菜单样式*/
    .is-active {
        background-color: #ebeffe;
    }

</style>
